var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.lang
    ? _c("div", { staticClass: "cookie-status" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.modal_show,
                expression: "modal_show"
              }
            ],
            staticClass: "row"
          },
          [
            _c("div", { staticClass: "cookies-status" }, [
              _c("div", { staticClass: "col" }, [
                _vm._v(_vm._s(_vm.lang.text) + " \n                "),
                _c("div", { staticClass: "mx-auto text-center pt-1" }, [
                  _c(
                    "button",
                    { staticClass: "btn bluecta", attrs: { type: "button" } },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "linkCookie",
                          attrs: {
                            rel: "noopener",
                            href: _vm.lang.policy_url,
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.lang.policy) +
                              "\n                        "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn bluecta",
                      attrs: { type: "button" },
                      on: { click: _vm.cookieAccept }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.lang.accept) +
                          "\n                    "
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }